import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { GroupDetailsComponent } from "./features/login-assistant/group-list/group-details/group-details.component";
import { GroupListComponent } from "./features/login-assistant/group-list/group-list.component";
import { LoginAssistantComponent } from "./features/login-assistant/login-assistant.component";
import { canActivateGroupDetails, canActivateGroupList, canActivateLoginAssistant, canActivateOrganisationList } from "./features/login-assistant/login-assistant.service";
import { OrganisationListComponent } from "./features/login-assistant/organisation-list/organisation-list.component";
import { authApiGroupsResolver, groupUsersResolver, loginAssistantGroupsResolver, loginAssistantOrganisationResolver } from "./features/login-assistant/resolver";
import { LoginComponent } from "./features/login/login.component";
import { canActivateLogin } from "./features/login/login.service";
import { LogoffComponent } from "./features/logoff/logoff.component";
import { PasswordUpdateComponent } from "./features/password-update/password-update.component";
import { canActivatePasswordUpdateScreen } from "./features/password-update/password-update.service";
import { routePaths } from "./routes";

const loginAssistantChildRoutes: Routes = [
  {
    path: routePaths.organisations,
    component: OrganisationListComponent,
    canActivate: [canActivateOrganisationList]
  },
  {
    path: routePaths.groups,
    component: GroupListComponent,
    canActivate: [canActivateGroupList],
    resolve: {
      organisation: loginAssistantOrganisationResolver,
      groups: loginAssistantGroupsResolver,
      authApiGroups: authApiGroupsResolver
    }
  },
  {
    path: `${routePaths.groups}/:groupKey`,
    component: GroupDetailsComponent,
    resolve: {
      users: groupUsersResolver
    },
    canActivate: [canActivateGroupDetails]
  }
];

const routes: Routes = [
  {
    path: "",
    component: LoginComponent,
    pathMatch: "full",
    canActivate: [canActivateLogin]
  },
  {
    path: routePaths.loginAssistant,
    component: LoginAssistantComponent,
    children: loginAssistantChildRoutes,
    canActivate: [canActivateLoginAssistant]
  },
  {
    path: routePaths.updatePassword,
    component: PasswordUpdateComponent,
    canActivate: [canActivatePasswordUpdateScreen]
  },
  {
    path: routePaths.logoff,
    component: LogoffComponent
  },
  {
    //workaround for windows IIS
    path: routePaths.login,
    redirectTo: "",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: ""
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
